import {
  getAppLocale,
  customTranslations,
  formatGameLink,
} from "../operator_specific/grandcasinobern";

const settings = {
  // baseApiUrl: "https://staging-api.vaix.ai",
  // vaixClientId: "grand_casino_bern",
  baseApiUrl: "https://api.vaix.ai",
  vaixClientId: "grandcasinobern",
  recsFields: "category",
  internalRecsFields: "game_link,min_bet,max_bet",
  recsFilters: "has_game_link:eq:true;min_bet:gt:0.0;max_bet:gt:0.0",
  widgetSettingsType: "widget_settings",
  getAppLocale: getAppLocale,
  translations: customTranslations,
  formatGameLink: formatGameLink,
  hasMultipleImageTypes: true,
  components: {
    sliderItem: {
      magnifyOnHover: false,
      showPlayBtnOnHover: false,
      tags: [
        {
          component: "minMaxTag",
          getProps: (item) =>
            item.max_bet &&
            item.min_bet && { max: item.max_bet, min: item.min_bet },
        },
        {
          component: "categoryTag",
          getProps: (item) => item.category && { value: item.category },
        },
      ],
    },
    slider: {
      moreBtnHover: false,
      itemsPerRow: {
        "500px": 3,
      },
    },
  },
  widgets: [
    {
      name: "vaix-carousel-widget",
    },
  ],
};

export default settings;
